import { Header } from '@amzn/awsui-components-react-v3';
import React from 'react';
import { MONTH_MAP } from '../../../utils/date-utils';

import { InfoLink, SpotcpInfo } from '../../spotcp/info';

export class FLCPHeader extends React.Component {

  constructor(props) {
    super(props);
  };

  formatDate = (timeFrame) => {
    return MONTH_MAP[timeFrame.slice(5)] + '-' + timeFrame.slice(2, 4);
  };

  render() {
    return (
      <Header
        variant="h1"
        description={this.props.payload ? this.formatDate(this.props.payload.timeFrame) : ''}
        info={<InfoLink onFollow={() => this.props.updateTools(<SpotcpInfo/>)} />}
      >
        FLCP Accuracy Report
      </Header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/flcp/flcp_header.jsx